import { createContext } from "react";
export var DeviceDataContext = createContext(null);